import React from 'react';
import { createPortal } from 'react-dom';
import { Tooltip, Paper, Box } from '@mui/material';
import { useMap, useMapEvents } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from '@mui/material';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useState, useEffect, useMemo, useRef } from 'react';
import LayersIcon from '@mui/icons-material/Layers';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Filter, FilterAlt } from '@mui/icons-material';
import { setModal } from '../../../store/reducers/helpersReducer';
import L from 'leaflet';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';




const RulesTableButton = () => {
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = useState(false)
    const buttonRef = useRef(null);
    const rules = useSelector(state => state.state.rules)
    const [count, setCount] = useState(0)
    const buttonPosition = useMemo(() => {
        const buttonRect = buttonRef.current?.getBoundingClientRect();
        return buttonRect ? {
            top: buttonRect.top,
            left: buttonRect.left,
            right: buttonRect.right,
            bottom: buttonRect.bottom,
            width: buttonRect.width,
            height: buttonRect.height
        } : null;
    }, [buttonRef.current]);


    useMapEvents({
        'modal:open': (e) => {
            if (e.modalType !== 'rulesTable') {
                setIsOpen(false)
            }
        },
        'modal:close': () => {
            setIsOpen(false)
        }
    })

    const handleOpenToggle = (newState) => {
        setIsOpen(newState)
        if (newState) {
            dispatch(setModal({ modalType: 'rulesTable', modalProps: { buttonPosition } }))
        } else {
            dispatch(setModal(null))
        }
    }


    useEffect(() => {
        if (rules) {
            setCount(rules.reduce((t, r) => t + r.rules.length, 0))
        }
    }, [rules])

    useEffect(() => {
        if (buttonRef.current) {
            L.DomEvent.disableClickPropagation(buttonRef.current)
            L.DomEvent.disableScrollPropagation(buttonRef.current)
        }
    }, [buttonRef.current])

    return createPortal(
        <Box sx={{ zIndex: 1202, display: 'flex', order: 5, pointerEvents: 'auto', width: 'fit-content' }}>
            <Tooltip title='Чек-лист контроля качества строительства' placement='right' arrow>
                <Paper
                    elevation={3}
                    ref={buttonRef}
                    sx={{
                        display: 'flex',
                        order: 3,
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: window.innerWidth < 768 ? 26 : 34,
                        height: window.innerWidth < 768 ? 26 : 34,
                        // m: '10px 10px 5px 5px',
                        opacity: 0.9,
                        bgcolor: 'rgb(40, 40, 40)',
                        boxShadow: '0px 2px 6px grey',
                        color: 'rgb(0, 174, 255)',
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        '&:hover': {
                            bgcolor: 'rgb(50, 50, 50)',
                            transform: 'scale(1.1)',

                        },
                        // zoom: window.innerWidth < 768 ? 0.8 : 1
                    }}
                    onClick={() => handleOpenToggle(!isOpen)}
                >
                    <ChecklistRtlIcon sx={{ fontSize: window.innerWidth < 768 ? 19 : 24, color: '#97ec37' }} />
                    <Box sx={{ position: 'relative', display: 'inline-block' }}>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="#97ec37" style={{ alignSelf: 'center' }}>
                                <path d="m576-160-56-56 104-104-104-104 56-56 104 104 104-104 56 56-104 104 104 104-56 56-104-104-104 104Zm79-360L513-662l56-56 85 85 170-170 56 57-225 226ZM80-280v-80h360v80H80Zm0-320v-80h360v80H80Z"
                                />
                            </svg> */}


                        {/* Badge для ready - нижний правый угол */}
                        {count > 0 && (
                            <Badge
                                badgeContent={count}
                                color="secondary"
                                max={999}
                                variant="standard"
                                sx={{
                                    position: 'absolute',
                                    bottom: window.innerWidth < 768 ? -14 : -16,
                                    right: window.innerWidth < 768 ? -2 : -4,
                                    '& .MuiBadge-badge': {
                                        color: 'black',
                                        backgroundColor: '#97ec37',
                                        fontSize: window.innerWidth < 768 ? 9 : 12,
                                        padding: '2px',
                                        width: 'auto',
                                        height: 'auto',
                                    }
                                }}
                            />
                        )}
                    </Box>


                </Paper>
            </Tooltip>
        </Box>

        , document.getElementById("map-controls-left-top")
    )




};

export default RulesTableButton; 